import { render, staticRenderFns } from "./PriorApproval.vue?vue&type=template&id=525aacf6"
import script from "./PriorApproval.vue?vue&type=script&lang=js"
export * from "./PriorApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports